import React from "react";
import "./SalesModel.css";

const SalesModel = (props) => (
    <div className={`sales-model ${props.isSelected && "sales-model--selected"}`} onClick={props.clickFunction}>
        <div className="sales-model-title">{props.modelTitle}</div>
        <div className="sales-model-text">{props.modelText}</div>
    </div>
)

export default SalesModel;